export function includeJSPromise(url) {
        return new Promise((resolve, reject) => {
                var headID = document.getElementsByTagName("head").item(0);

                const node = document.createElement("script");
                node.src = url;

                node.onload = resolve;
                node.onerror = reject;

                headID.appendChild(node);
        });
}